export type PendingCouponFormValues = {
  openId: string;
  mobile: string;
};

export type PendingCouponPayload = {
  openId: string;
  userId: string;
  mobile: string;
};

const trimText = (value: unknown) => {
  if (value === undefined || value === null) return '';
  return String(value).trim();
};

export const buildPendingCouponPayload = (values: PendingCouponFormValues): PendingCouponPayload => {
  const openId = trimText(values.openId);
  return {
    openId,
    userId: openId,
    mobile: trimText(values.mobile),
  };
};
